import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { PatientDocument } from 'src/models';
import { ambientApi } from 'src/services';

export type UseGetEncounterDocumentListParams = {
  encounterId: string;
};

export type UseGetEncounterDocumentListOptions = Omit<
  UseQueryOptions<any>,
  'queryKey' | 'queryFn'
>;

export type GetEncounterDocumentListResponse = {
  encounter_documents: PatientDocument[];
};

export const useGetEncounterDocumentList = (
  params: UseGetEncounterDocumentListParams,
  options?: UseGetEncounterDocumentListOptions
) => {
  return useQuery({
    queryKey: ['encounterDocumentList', params],
    queryFn: () =>
      ambientApi
        .get<GetEncounterDocumentListResponse>(
          `/encounters/${params.encounterId}/documents`
        )
        .then(({ data }) => ({
          encounterDocuments: data.encounter_documents || [],
        })),
    ...options,
  });
};
